export const BEING_ID_LEVELS = [
  { level: 1, label: 'Government Witness', description: 'Government-Issued ID Created' },
  { level: 2, label: 'Government Real ID', description: 'Government Validation Added' },
  { level: 3, label: 'Secondary Government ID', description: 'Multiple IDs Added' },
  { level: 4, label: 'Witness Confirmation', description: 'VDT Created at Kiosk' },
  { level: 5, label: 'Multiple Events', description: 'Higher Level Witnesses Added' },
  { level: 6, label: 'Human', description: 'Account Created, Biometric Template Recorded' },
];

export const HARDWARE_LEVELS = [
  { level: 1, label: 'Stationary Kiosk on BIT Trusted Network', color: '#6BAF23', bgColor: '#d3e9bb' },
  { level: 2, label: 'Floating Kiosk on BIT Trusted Network', color: '#0C682A', bgColor: '#8BE7A9' },
  { level: 3, label: 'Verifed Personal Devices on Public Network', color: '#02381B', bgColor: '#81B79A' },
  { level: 4, label: 'Unverifed Personal Devices on Public Network', color: '#191617', bgColor: '#989596' },
];
